const PREFIXES = {
    DOCKER: "http://0.0.0.0:8000",
    //LOCAL: "http://localhost:8001",
    LOCAL: "https://api.wagner-polska.com.pl",
};

export const PREFIX = (process.env.REACT_APP_API_HOST ? process.env.REACT_APP_API_HOST : PREFIXES.LOCAL) + '/api/v1';

export const API = {
    AUTH: `${PREFIX}/token/`,
    REFRESH: `${PREFIX}/token/refresh/`,
    USERS: `${PREFIX}/users/`,
    OPTIMA_USERS: `${PREFIX}/optima-users/`,
    CUSTOMERS: `${PREFIX}/contractors/`,
    SERVICE_ORDERS: `${PREFIX}/service-orders/`,
    WAREHOUSES: `${PREFIX}/warehouses/`,
    DEVICES: `${PREFIX}/devices/`,
    CATEGORIES: `${PREFIX}/categories/`,
    DOCUMENTS_TYPES: `${PREFIX}/document-types/`,
    NOTES: `${PREFIX}/notes/`,
    STAGES: `${PREFIX}/stages/`,
    ATTRIBUTES: `${PREFIX}/attributes/`,
    ATTRIBUTES_DEFINITION: `${PREFIX}/attributes-definition/`,
    ATTRIBUTES_DEFINITION_ITEMS: `${PREFIX}/attributes-definition-items/`,
    PRODUCTS: `${PREFIX}/products/`,
    ACTIVITIES: `${PREFIX}/service-activities/`,
    EMAIL_TEMPLATES: `${PREFIX}/email-templates/`,
    GENERAL_SETTINGS: `${PREFIX}/general-settings/`,
    LOGS: `${PREFIX}/logs/`,
    EMAILS_SENT: `${PREFIX}/emails-sent/`,
    SHIPPING: `${PREFIX}/shipping/`,
    SHIPPING_ADDRESS: `${PREFIX}/shipping-addresses/`,
    SHIPPING_STATUSES: `${PREFIX}/shipping-statuses/`,
    STATUSES: `${PREFIX}/statuses/`,
    COUNTRIES: `${PREFIX}/countries/`,
    TAXES: `${PREFIX}/taxes/`,
    ORDER_TYPES: `${PREFIX}/order-types/`,
    SHIPPING_COMPANIES: `${PREFIX}/shipping-companies/`,
    SHIPPING_METHODS: `${PREFIX}/shipping-methods/`,
    SHIPPING_OPTIONS: `${PREFIX}/shipping-options/`,
    TEST_EMAIL: `${PREFIX}/send-test-message/`,
}